export default __webpack_public_path__ + "static/media/AwesomeAir_09.dfc7e7c1.png";